import {PreordersEmailModel, UserRequests} from "@/app/api/user";
import {useCallback, useState} from "react";

interface ScreenState {
  hasError?: string;
  hasLoading?: boolean;
  emails: PreordersEmailModel[]
}

const useEmailsInWhiteList = () => {
  const [state, setState] = useState<ScreenState>({
    hasError: undefined,
    hasLoading: false,
    emails: []
  });

  const updateState = useCallback((updates: Partial<ScreenState>) => {
    setState((prev) => ({...prev, ...updates}));
  }, []);

  const init = useCallback(async () => {
    updateState({hasLoading: true});
    try {
      const response = await UserRequests.getPreordersEmails();
      updateState({emails: response});
    } catch (error: any) {
      updateState({hasError: error.message});
    } finally {
      updateState({hasLoading: false});
    }
  }, [updateState]);


  return {
    state,
    init
  };
};

export default useEmailsInWhiteList;